module.exports = __webpack_public_path__ + "assets/img/sabc_burger_menu_icon.svg?5e217fadf0a5b6c14983b6cf7fa63992";